var bittoelatings_c = [{
        rule: "pesverkenning:create",
        bitmask: "1",
        blok: 2,
        beskrywing: "Neem 'n pes lesing",
        groepe: ["pesverkenning", "aktiwiteite", "verkenning"],
    },
    {
        rule: "pesverkenning:read",
        bitmask: "2",
        blok: 2,
        beskrywing: "Lees van pes lesings",
        groepe: ["pesverkenning", "aktiwiteite", "verkenning"],
    },
    {
        rule: "pesverkenning:update",
        bitmask: "4",
        blok: 2,
        beskrywing: "Veranderinge aan pes lesings",
        groepe: ["pesverkenning", "aktiwiteite", "verkenning"],
    },
    {
        rule: "pesverkenning:delete",
        bitmask: "8",
        blok: 2,
        beskrywing: "Verwydering van pes lesings",
        groepe: ["pesverkenning", "aktiwiteite", "verkenning"],
    },
    {
        rule: "clocking:create",
        bitmask: "16",
        blok: 2,
        beskrywing: "In- en uitklok van werknemers",
        groepe: ["clocking"],
    },
    {
        rule: "clocking:read",
        bitmask: "32",
        blok: 2,
        beskrywing: "Lees van werknemers se klok rekords (en Rapportering)",
        groepe: ["clocking"],
    },
    {
        rule: "clocking:update",
        bitmask: "64",
        blok: 2,
        beskrywing: "Veranderinge aan klok rekords",
        groepe: ["clocking"],
    },
    {
        rule: "clocking:delete",
        bitmask: "128",
        blok: 2,
        beskrywing: "Verwydering van 'n klok rekord",
        groepe: ["clocking"],
    },
    {
        rule: "clockingopstellings:update",
        bitmask: "256",
        blok: 2,
        beskrywing: "Verandering aan klok opstellings en notifikasies",
        groepe: ["clocking", "setup"],
    },
    {
        rule: "plukstate:create",
        bitmask: "512",
        blok: 2,
        beskrywing: "Skep van plukstate",
        groepe: ["plukstate", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukstate:read",
        bitmask: "1024",
        blok: 2,
        beskrywing: "Lees van plukstate",
        groepe: ["plukstate", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukstate:update",
        bitmask: "2048",
        blok: 2,
        beskrywing: "Verandering aan plukstate",
        groepe: ["plukstate", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukstate:delete",
        bitmask: "4096",
        blok: 2,
        beskrywing: "Verwydering van plukstate",
        groepe: ["plukstate", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukrekordstoep:create",
        bitmask: "8192",
        blok: 2,
        beskrywing: "Skryf van plukrekords (dmv toep)",
        groepe: ["plukrekords", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukrekords:create",
        bitmask: "16384",
        blok: 2,
        beskrywing: "Invoer van plukrekords (dmv portaal)",
        groepe: ["plukrekords", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukrekords:read",
        bitmask: "32768",
        blok: 2,
        beskrywing: "Lees van plukranglys",
        groepe: ["plukrekords", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukrekords:update",
        bitmask: "65536",
        blok: 2,
        beskrywing: "Verandering aan plukrekords",
        groepe: ["plukrekords", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukrekords:delete",
        bitmask: "131072",
        blok: 2,
        beskrywing: "Verwyder van plukrekords",
        groepe: ["plukrekords", "aktiwiteite", "pluk"],
    },
    {
        rule: "plukstaatplukteiken:update",
        bitmask: "262144",
        blok: 2,
        beskrywing: "Verandering van plukteiken per plukstaat",
        groepe: ["aktiwiteite", "pluk"],
    },
    {
        rule: "plukstaatkoppelling:update",
        bitmask: "524288",
        blok: 2,
        beskrywing: "Plukstate koppellings maak met lewerings",
        groepe: ["plukstaat", "aktiwiteite", "pluk"],
    },
    {
        rule: "pluk:rapportering",
        bitmask: "1048576",
        blok: 2,
        beskrywing: "Rapportering van plukprestasie",
        groepe: ["aktiwiteite", "pluk"],
    },
    {
        rule: "plukopstellings:update",
        bitmask: "2097152‬",
        blok: 2,
        beskrywing: "Verandering aan pluk opstellings en notifikasie",
        groepe: ["aktiwiteite", "pluk"],
    },
    {
        rule: "transaksielog:read",
        bitmask: "4194304‬",
        blok: 2,
        beskrywing: "Lees van transaksie log",
        groepe: ["debug"],
    },
    {
        rule: "plukbonusse:rapportering",
        bitmask: "8388608",
        blok: 2,
        beskrywing: "Rapportering van plukbonusse",
        groepe: ["aktiwiteite", "pluk", "rapportering"],
    },
    {
        rule: "besproeiing:skakel",
        bitmask: "16777216",
        blok: 2,
        beskrywing: "Skakel pompe aan/af",
        groepe: ["aktiwiteite", "besproeiing"],
    },
    {
        rule: "besproeiing:lees",
        bitmask: "33554432",
        blok: 2,
        beskrywing: "Lees pomp status",
        groepe: ["aktiwiteite", "besproeiing"],
    },
    {
        rule: "subskripsie:create",
        bitmask: "67108864",
        blok: 2,
        beskrywing: "Skep van 'n subskripsie",
        groepe: ["subskripsies", "setup"],
    },
    {
        rule: "subskripsie:read",
        bitmask: "134217728",
        blok: 2,
        beskrywing: "Lees van subskripsies",
        groepe: ["subskripsies", "setup"],
    },
    {
        rule: "subskripsie:update",
        bitmask: "268435456",
        blok: 2,
        beskrywing: "Verander subskripsies",
        groepe: ["subskripsies", "setup"],
    },
    {
        rule: "subskripsie:delete",
        bitmask: "536870912",
        blok: 2,
        beskrywing: "Verwyder 'n subskripsie",
        groepe: ["subskripsies", "setup"],
    },
    {
        rule: "pluk:rekordsverander",
        bitmask: "1073741824",
        blok: 2,
        beskrywing: "Verander aan plukrekords",
        groepe: ["pluk"],
    },
    {
        rule: "clockingviaportaal:create",
        bitmask: "2147483648",
        blok: 2,
        beskrywing: "In- en uitklok van werknemers via portaal",
        groepe: ["clocking"],
    },
];

export default bittoelatings_c;